"use client";

import { Fragment, useCallback, useContext, useEffect, useState } from "react";

import StepContainer from "../../../components/new_components/StepContainer";
import FilterableSelect from "../../../components/new_components/FilterableSelect";
import CardSelect from "../../../components/new_components/CardSelcted";
import { loadData } from "../../../services/loadCitys";
import {
  bankAccountOptions,
  maritalStatusOptions,
  educationLevelOptions,
  ocupationOptions,
  homologateBankNameAccount,
} from "../../../utils/options_selects";
import { InfoAlert } from "../../../components/alerts/infoAlert";
import StepInput from "../../../components/new_components/StepInput";
import { capitalizeFirstLetter } from "../../../utils/capitalize";
import {
  removeAccents,
  removeSpecialCharsAndEmojis,
} from "../../../utils/validacionesForms";
import { FormOneContext } from "../../../context/FormOne/FormOneContext";
import { FormTwoContext } from "../../../context/FormTwo/FormTwoContext";
import { variablesGlobales } from "../../../configs/variables";
import { HttpRequest } from "../../../services/httpRequest";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { CreditUserContext } from "../../../context/CreditUser/CreditUserContext";
import { useCreditStore } from "../../../store/creditStore/creditUserStore";
import { stepsCreditStore } from "../../../store/creditStore/stepsCreditStore";
import { creditOfferStore } from "../../../store/creditStore/offerCreditStore";
import { useNavigate } from "react-router-dom";
import { rangoMonto, resultadoEvaluacion, trackEvent } from "../../../services/analytics/track";
import {
  IdCard,
  Landmark,
  Phone,
} from "lucide-react";
import { AuthService } from "../../../services/auth/auth.service";
import { BottomSheet } from "../../../components/new_components/BottomSheet";
import { useWindowSize } from "../helpers/bankDimensions";
import {
  NextButton,
  PrevButton,
} from "../../../components/new_components/buttonsFlow";
import { CameraIcon } from "@heroicons/react/24/solid";
import { useMobileDetection } from "../../../hooks/use-mobile-detection";

const DatosPersonalesForm = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const navigate = useNavigate();

  useWindowSize();
  const { screenHeight } = useMobileDetection();

  const { creditUserStore, saveUser, loadUser, clearUser } = useCreditStore();
  const { stepCredit, saveSteps, loadSteps, clearSteps } = stepsCreditStore();
  const { saveOfertCredit } = creditOfferStore();

  const [isDesktopReize, setIsDesktopReize] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [justification, setJusticification] = useState("start");
  const [marginTop, setMarginTop] = useState("0px");
  const [height, setHeight] = useState("auto");
  const [currentStepResume, setCurrentStepResume] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [currentText, setCurrentText] = useState("Continuar");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [jsonPlaces, setJsonPlaces] = useState([]);
  const [, setCitysSelect] = useState([]);
  const [errors, setErrors] = useState({});
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenError, setIsOpenError] = useState(false);
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [newBankAccount, setNewBankAccount] = useState([]);
  const { updateFormOne } = useContext(FormOneContext);
  const { updateFormTwo } = useContext(FormTwoContext);
  const { updateCreditUser } = useContext(CreditUserContext);
  const [openDialogInfo, setOpenDialogInfo] = useState(false);

  const [dialogOpenBankSelected, setDialogOpenBankSelected] = useState(false);

  const payload = {};

  const cupoAprobado = "200000";

  const [formData, setFormData] = useState({
    // Step 1: Names
    firstname: "",
    secondname: "",
    firstlastname: "",
    secondlastname: "",

    // Step 2: Personal Info
    requestedAmount: "",
    //age: 33,
    // Step 3: Personal Info
    maritalStatus: "",
    // Step 4: Personal Info
    //gender: "",
    // Step 5: Personal Info
    educationLevel: "",
    // Step 6: Location
    //depAddress: "",
    //cityAddress: "",
    // Step 7: Work Info
    ocupation: "",
    monthlyExpenses: "",
    // Step 5: Banking
    bankAccount: "",
  });

  const stepTitles = [
    "¿Cuál es tu primer apellido?",
    //"¿Qué edad tienes?",
    "Digita el monto a solicitar",
    "¿Cuál es tu estado civil?",
    //"¿Con qué género te identificas?",
    "¿Cuál es tu nivel educativo?",
    //"¿En qué departamento y ciudad vives?",
    "¿A qué te dedicas?",
    "¿Cuantos son tus ingresos mensuales?",
    "¿Dónde recibes tus ingresos?",
    "Woohoo!!, casi listos 🚀✨",
  ];

  const stepSubTitles = [
    "Para continuar con tu solicitud, necesitamos saber tu primer apellido. Esto nos permite evaluar tu perfil y ofrecerte las mejores opciones.",
    //"Para continuar con tu solicitud, necesitamos saber tu edad. Esto nos permite evaluar tu perfil y ofrecerte las mejores opciones.",
    "Para continuar con tu solicitud, necesitamos saber cuál es el monto que requieres. Esto nos permite evaluar tu perfil y ofrecerte las mejores opciones.",
    "Para continuar con tu solicitud, necesitamos saber tu estado civil. Esto nos permite evaluar tu perfil y ofrecerte las mejores opciones.",
    //"Para seguir con tu solicitud, necesitamos conocer tu género. Esto nos ayuda a evaluar tu perfil y recomendarte las mejores opciones disponibles.",
    "Para continuar con tu solicitud, necesitamos conocer tu nivel educativo. Esto nos ayuda a evaluar tu perfil y recomendarte las mejores opciones disponibles.",
    //"Para avanzar con tu solicitud, es importante saber dónde resides. Esta información nos permite analizar tu perfil de manera más precisa y sugerirte las opciones más adecuadas para ti.",
    "Para proceder con tu solicitud, necesitamos saber a qué te dedicas actualmente, Esto nos permite evaluar tu perfil de forma más completa.",
    "Para proceder con tu solicitud, necesitamos saber cuantos son tus ingresos mensuales, ten en cuenta que verificaremos tus ingresos.",
    "Revisaremos tus ingresos en el banco que nos suministres para determinar tu capacidad de pago.",
    isDesktopReize &&
    "Hemos completado el primer paso de 4. Aquí va un resumen de la información que hemos recopilado hasta ahora:",
  ];

  const totalSteps = stepTitles.length;

  const getFormHeight = () => {
    if (screenHeight <= 490) return "200px"; 
    if (screenHeight <= 550) return "260px";
    if (screenHeight <= 599) return "300px";
    if (screenHeight <= 650) return "370px";
    if (screenHeight <= 700) return "390px";
    if (screenHeight <= 800) return "470px";
    if (screenHeight <= 1000) return "660px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let valueParsed = "";
    let textCapitalize = "";
    // Clear error when user starts typing

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setIsError(true);
    }

    if (name === "firstlastname") {
      textCapitalize = capitalizeFirstLetter(value);
      valueParsed = removeAccents(textCapitalize);
      valueParsed = removeSpecialCharsAndEmojis(valueParsed);
      setFormData((prev) => ({ ...prev, [name]: valueParsed }));
      setIsError(false);
      setIsDisabled(false);
      return;
    }

    // if (name === "depAddress") {
    //   setFormData((prev) => ({ ...prev, ["cityAddress"]: "" }));
    //   if (value === "Bogotá DC") {
    //     setFormData((prev) => ({ ...prev, ["cityAddress"]: "Bogotá" }));
    //   }
    //   handleFilterCity(value);
    // }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setIsError(false);
    // if (name !== "depAddress") {
    setIsDisabled(false);
    // }
  };

  const handleAmountChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    let numericValue = parseInt(value, 10);
    if (isNaN(numericValue)) {
      numericValue = 0;
    }

    handleInputChange({
      target: {
        name: e.target.name,
        value: new Intl.NumberFormat("es-CO").format(numericValue),
      },
    });
  };

  const editOptions = (numberStep) => {
    setMarginTop("0px");
    setHeight("auto");
    setJusticification("start");
    setCurrentText("Volver al resumen");
    setCurrentStep(numberStep);
    setCurrentStepResume(true);
    setIsError(false);
  };

  const handleOpenAlertInfo = (type, message, isOpen) => {
    /* if (type === "success") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenSuccess(isOpen);
    } */

    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const handleToggleDialogBankSelected = (value) => {
    if (value) {
      setDialogOpenBankSelected(false);
      setTimeout(() => {
        handleNext();
      }, 500);
    } else {
      setDialogOpenBankSelected(!dialogOpenBankSelected);
    }
  };

  const handleClearStateAlert = () => {
    setMessageAlert("");
  };

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      // case 1:
      //   if (!formData.firstname.trim()) newErrors.firstname = "El primer nombre es obligatorio"
      //   if (!formData.firstlastname.trim()) newErrors.firstlastname = "El primer apellido es obligatorio"
      //   break
      case 1:
        if (formData.firstlastname.length < 2) {
          setIsDisabled(true);
          newErrors.firstlastname =
            "¡Ups! Como mínimo debe tener 2 caracteres.";
        }
        if (!formData.firstlastname) {
          newErrors.firstlastname = "Digita tu primer apellido";
          setIsDisabled(true);
        }
        break;

      case 2:
        let requestedAmount = parseInt(
          formData.requestedAmount.replace(/\./g, ""),
          10,
        );

        if (requestedAmount > 500000) {
          newErrors.requestedAmount = "¡Ups! El monto sobrepasa los $500.000";
          setIsDisabled(true);
        }
        if (requestedAmount < 200000) {
          newErrors.requestedAmount =
            "¡Ups! El monto debe ser mayor o igual a $200.000";
          setIsDisabled(true);
        }
        if (!requestedAmount) {
          newErrors.requestedAmount = "Digita el monto a solicitar";
          setIsDisabled(true);
        }
        break;
      // case 2:
      // if (!formData.age || formData.age < 18 || formData.age > 99) {
      //   newErrors.age = "Debes tener entre 18 y 99 años";
      //   setIsDisabled(true);
      // }

      // break;
      case 3:
        if (!formData.maritalStatus) {
          newErrors.maritalStatus = "Selecciona tu estado civil";
          setIsDisabled(true);
        }
        break;
      // case 4:
      //   if (!formData.gender) {
      //     newErrors.gender = "Selecciona tu género";
      //     setIsDisabled(true);
      //   }
      //   break;
      case 4:
        if (!formData.educationLevel) {
          newErrors.educationLevel = "Selecciona tu nivel educativo";
          setIsDisabled(true);
        }
        break;
      // case 6:
      //   if (
      //     formData.depAddress === "Seleccione una opción." ||
      //     !formData.depAddress
      //   ) {
      //     newErrors.depAddress = "Selecciona tu departamento";
      //     setIsDisabled(true);
      //   }
      //   if (
      //     formData.cityAddress === "Seleccione una opción." ||
      //     !formData.cityAddress
      //   ) {
      //     newErrors.cityAddress = "Selecciona tu ciudad";
      //     setIsDisabled(true);
      //   }
      //   break;
      case 5:
        if (!formData.ocupation) {
          newErrors.ocupation = "Selecciona tu ocupación";
          setIsDisabled(true);
        }
        break;
      case 6:
        let monthlyExpenses = parseInt(
          formData.monthlyExpenses.replace(/\./g, ""),
          10,
        );

        if (monthlyExpenses < 1000000) {
          newErrors.monthlyExpenses =
            "¡Ups! Tus ingresos deben ser igual o superior a $1.000.000.";
          setIsDisabled(true);
        }
        if (!monthlyExpenses) {
          newErrors.monthlyExpenses = "Digita tus ingresos";
          setIsDisabled(true);
        }
        break;
      case 7:
        if (!formData.bankAccount) {
          newErrors.bankAccount = "Selecciona tu banco";
          setIsDisabled(true);
        }
        break;
      case 8:
        if (!formData.maritalStatus)
          newErrors.maritalStatus = "Selecciona tu estado civil";
        // if (!formData.gender) newErrors.gender = "Selecciona tu género";
        if (!formData.educationLevel)
          newErrors.educationLevel = "Selecciona tu nivel educativo";
        // if (!formData.cityAddress) {
        //   newErrors.cityAddress = "Selecciona tu ciudad";
        // }
        if (!formData.ocupation) {
          newErrors.ocupation = "Selecciona tu ocupación";
        }
        break;
      default:
        break;
    }

    setErrors(newErrors);
    setIsError(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (validateStep(currentStep)) {
      if (currentStep < totalSteps) {
        if (currentStep === 7 && !currentStepResume) {
          handleOpenAlertInfo(
            "info",
            "Al enviar esta solicitud, nuestra tecnologia analizará y respondera en segundos.",
            true,
          );
        }
        if (currentStepResume) {
          setMarginTop("100px");
          setHeight("100vh");
          setCurrentStep(totalSteps);
          setCurrentStepResume(false);
          setIsError(false);
          return;
        }

        setIsTransitioning(true);
        setCurrentText("Continuar");

        setIsError(false);
        setTimeout(() => {
          setCurrentStep((prev) => prev + 1);
          if (currentStep === 7) {
            setMarginTop("100px");
            setHeight("100vh");
            setIsDisabled(false);
          }
          setIsTransitioning(false);
        }, 50);
        saveSteps({
          stepInternal: currentStep + 1,
          stepGeneral: parentStep,
          loading: false,
        });
      } else {
        handleSubmit();
      }
    }

    saveUser(formData);

    setIsDisabled(true);
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setIsDisabled(false);
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev - 1);

        setIsTransitioning(false);
        setIsError(false);
      }, 150);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    updateFormOne(formData);
    updateFormTwo(formData);

    try {
      /*       if (!isValidReCaptcha) {
        setIsLoading(false);
        return handleOpenAlertInfo(
          "error",
          "Debe validar el captcha para continuar .",
          true
        );
      } */
      let coords = localStorage.getItem("coords");

      const monthlyExpenses = formData.monthlyExpenses.replace(/\./g, "");
      const requestedAmount = formData.requestedAmount.replace(/\./g, "");

      const cleanedData = {
        ...formData,
        monthlyExpenses,
      };

      if (cleanedData.bankAccount === 10) {
        trackEvent("evaluacion_completada", { resultado: "negado", tipo_cliente: "nuevo" });
        localStorage.setItem("credit_aprobate", false);
        return;
      }

      Object.assign(payload, {
        formData: cleanedData,
        requestedAmount,
        doc: localStorage.getItem("doc"),
        coords: JSON.parse(coords),
        credit_id: localStorage.getItem("credit_id"),
      });

      await new Promise((resolve) => setTimeout(resolve, 2000));
      const responseService =
        await HttpRequest.sendPayloadFormsExperian(payload);
      if (responseService.error) {
        trackEvent("evaluacion_completada", { resultado: "error", tipo_cliente: "nuevo" });
        if (responseService.message.errorCode === 506) {
          clearSteps();
          clearUser();
          return navigate("/error");
        }

        localStorage.setItem("type_user", variablesGlobales.typeUserVisitor);
        localStorage.setItem("credit_aprobate", false);
        return;
      }
      localStorage.setItem("statusCredit", responseService.message.message);
      if (responseService.message.message !== "APRUEBA") {
        trackEvent("evaluacion_completada", { resultado: resultadoEvaluacion(responseService.message.message), tipo_cliente: "nuevo" });
      }
      if (responseService.message.message === "APRUEBA") {
        localStorage.setItem("credit_aprobate", true);
        const { info } = await getCreditById();
        trackEvent("evaluacion_completada", {
          resultado: "preaprobado",
          rango_monto: rangoMonto(info?.approvedQuota || cupoAprobado),
          tipo_cliente: "nuevo",
        });
        if (info) {
          const fullName = responseService.message.fullName;

          if (fullName) {
            setFormData({
              firstname: fullName.firstname ?? "",
              secondname: fullName.secondname ?? "",
              firstlastname: fullName.firstlastname ?? "",
              secondlastname: fullName.secondlastname ?? "",
              ...formData,
            });
          }

          saveUser({
            ...formData,
            firstname: fullName.firstname ?? "",
            secondname: fullName.secondname ?? "",
            firstlastname: fullName.firstlastname ?? "",
            secondlastname: fullName.secondlastname ?? "",
          });
          saveOfertCredit({
            ...info,
            numberDocument: info.documento,
            email: localStorage.getItem("email"),
            phone: localStorage.getItem("phone"),
          });
          updateCreditUser({
            credit_id: info.credit_id,
            approvedQuota: info.approvedQuota || cupoAprobado,
            termInDays: info.termInDays,
            totalToPay: info.totalToPay,
            paydayLimit: info.paydayLimit,
            documento: info.documento,
            acceptanceDate: info.acceptanceDate,
            approvedDate: info.approvedDate,
            status: info.status,
          });
          localStorage.setItem("type_user", variablesGlobales.typeUSerClient);
          localStorage.setItem("is_signin", true);
        }
      }

      let response = await AuthService.generateTokenClient({
        doc: localStorage.getItem("doc"),
      });
      localStorage.setItem("token", response?.message?.otp);
      setAlertSession(false);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      if (onStepChange) {
        onStepChange(parentStep + 1);
      }
      setIsLoading(false);
    }
    handleClearStateAlert();
  };

  const getCreditById = async () => {
    try {
      let credit_id = localStorage.getItem("credit_id");
      if (!credit_id)
        throw Error("No existe en localstorage el atributo credit_id");
      const { message } = await HttpRequest.getCreditById(
        localStorage.getItem("credit_id"),
      );
      return message;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const loadDepartaments = async () => {
    try {
      const data = await loadData();

      setJsonPlaces(data.places);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilterCity = useCallback(
    (dep) => {
      try {
        const citysFiltered = jsonPlaces.filter(
          (val) => val.departamento === dep,
        );
        setCitysSelect(citysFiltered[0].ciudades);
        return;
      } catch (error) {
        return;
      }
    },
    [jsonPlaces],
  );

  function getBankAccount() {
    const result = bankAccountOptions.filter((resp) => resp.value !== 9);
    setNewBankAccount(result);
  }

  const handleOpenDialogInfoAccount = useCallback((e) => {
    setOpenDialogInfo((prev) => !prev);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      handleOpenDialogInfoAccount();
    }, 1000);
  }, [handleOpenDialogInfoAccount]);

  useEffect(() => {
    const loadDepts = async () => {
      await loadDepartaments();
    };

    try {
      loadDepts().then(async () => {
        setIsLoading(false);
        setIsDisabled(true);
      });
      getBankAccount();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    loadUser();
    loadSteps();
  }, [loadUser, loadSteps]);

  useEffect(() => {
    if (stepCredit && stepCredit.loading) {
      setCurrentStep(stepCredit.stepInternal);
    }
    if (creditUserStore) {
      setFormData(creditUserStore);
      if (creditUserStore.depAddress) {
        handleFilterCity(creditUserStore.depAddress);
      }
    }
  }, [stepCredit, creditUserStore, handleFilterCity]);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsDesktopReize(window.innerWidth >= 1000 && window.innerHeight >= 945);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div
            className="space-y-6 text-center flex flex-col px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
              gap: isDesktop
                ? "clamp(20px, 3vh, 40px)"
                : "clamp(16px, 2vh, 24px)",
              padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                ¿Cuál es tu primer apellido?
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <StepInput
                name="firstlastname"
                value={formData.firstlastname}
                label={"Primer apellido"}
                onChange={handleInputChange}
                error={errors.firstlastname}
                required
                placeholder="Perez"
                autoFocus={true}
                type="text"
                isDesktop={isDesktop}
              />
            </div>
          </div>
        );

      case 2:
        return (
          <div
            className="space-y-6 text-center flex flex-col px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
              gap: isDesktop
                ? "clamp(20px, 3vh, 40px)"
                : "clamp(16px, 2vh, 24px)",
              padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                Digita el monto a solicitar
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <StepInput
                name="requestedAmount"
                inputMode="numeric"
                value={formData.requestedAmount}
                label={"Digita el monto a solicitar"}
                onChange={handleAmountChange}
                error={errors.requestedAmount}
                required
                placeholder="200.000"
                autoFocus={true}
                minLength={6}
                maxLength={7}
                type="text"
                isDesktop={isDesktop}
                iconLeft={<span className="text-xl">$</span>}
              />
              <div
                className="bg-grayP"
                style={{
                  borderRadius: "12px",
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background: "#2a2550",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="text-xl">$</span>
                </div>
                <p style={{ fontSize: "14px", margin: 0, textAlign: "start" }}>
                  <span style={{ color: "white" }}>
                    Tu primer crédito en Galilea desde $200.000 hasta $500.000
                  </span>
                </p>
              </div>
            </div>
          </div>
        );

      // case 2:
      // return (
      //   <div
      //     className="flex flex-col items-center justify-center text-center px-4 sm:px-6"
      //     style={{
      //       height: isDesktop && "-webkit-fill-available",
      //       display: isDesktop && "flex",
      //       justifyContent: isDesktop && "center",
      //     }}
      //   >
      //     {!isDesktop && (
      //       <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl mb-6">
      //         ¿Qué edad tienes?
      //       </p>
      //     )}
      //     <div className="w-full max-w-[320px]" style={{ height: "53%" }}>
      //       <SelectScroll
      //         name="age"
      //         data={edades}
      //         value={formData.age}
      //         isDesktop={isDesktop}
      //         onChange={handleInputChange}
      //       />
      //     </div>
      //   </div>
      // );

      case 3:
        return (
          <div
            className="flex flex-col items-center justify-center px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl text-center mb-6">
                ¿Cuál es tu estado civil?
              </p>
            )}
            <div className="w-full max-w-sm">
              <CardSelect
                data={maritalStatusOptions}
                value={formData.maritalStatus}
                name="maritalStatus"
                error={errors.maritalStatus}
                onChange={handleInputChange}
                multiple={false}
                isDesktop={isDesktop}
              />
            </div>
          </div>
        );

      // case 4:
      //   return (
      //     <div
      //       className="space-y-6 text-center px-4 sm:px-6"
      //       style={{
      //         height: isDesktop && "-webkit-fill-available",
      //         display: isDesktop && "flex",
      //         justifyContent: isDesktop && "center",
      //       }}
      //     >
      //       {!isDesktop && (
      //         <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
      //           ¿Con qué género te identificas?
      //         </p>
      //       )}
      //       <div
      //         className="w-full mx-auto"
      //         style={{
      //           maxWidth: "33rem",
      //         }}
      //       >
      //         <CardSelect
      //           data={genderOptions}
      //           value={formData.gender}
      //           name="gender"
      //           onChange={handleInputChange}
      //           error={errors.gender}
      //           multiple={false}
      //           isDesktop={isDesktop}
      //         />
      //       </div>
      //     </div>
      //   );

      case 4:
        return (
          <div
            className="flex flex-col items-center justify-center space-y-6 text-center px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                ¿Cuál es tu nivel educativo?
              </p>
            )}

            <div
              className="w-full mx-auto"
              style={{
                maxWidth: "33rem",
                display: isDesktop && "flex",
                alignItems: isDesktop && "space-around",
                flexWrap: isDesktop && "wrap",
              }}
            >
              <CardSelect
                data={educationLevelOptions}
                value={formData.educationLevel}
                name="educationLevel"
                onChange={handleInputChange}
                error={errors.educationLevel}
                multiple={false}
                isDesktop={isDesktop}
              />
            </div>
          </div>
        );

      // case 6:
      //   return (
      //     <div
      //       className="space-y-6 text-center flex flex-col px-4 sm:px-6"
      //       style={{
      //         height: isDesktop && "-webkit-fill-available",
      //         display: isDesktop && "flex",
      //         justifyContent: isDesktop && "center",
      //         gap: isDesktop
      //           ? "clamp(20px, 3vh, 40px)"
      //           : "clamp(16px, 2vh, 24px)",
      //         padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
      //       }}
      //     >
      //       {!isDesktop && (
      //         <p
      //           className="text-muted-foreground font-bold2"
      //           style={{
      //             fontSize: "clamp(18px, 2.2vw, 24px)",
      //             textAlign: "center",
      //             maxWidth: "400px",
      //             margin: "0 auto",
      //             lineHeight: "1.3",
      //           }}
      //         >
      //           ¿En qué departamento y ciudad vives?
      //         </p>
      //       )}

      //       <div
      //         style={{
      //           display: "flex",
      //           flexDirection: "column",
      //           gap: "clamp(16px, 2.5vh, 32px)",
      //           minHeight: 0,
      //           maxWidth: isDesktop ? "600px" : "100%",
      //           width: "100%",
      //           margin: "0 auto",
      //         }}
      //       >
      //         {/* Departamento */}
      //         <div>
      //           <FilterableSelect
      //             options={jsonPlaces.map((dept) => ({
      //               label: dept.departamento,
      //               value: dept.departamento,
      //             }))}
      //             label={"Departamento"}
      //             value={formData.depAddress}
      //             onChange={handleInputChange}
      //             name="depAddress"
      //             placeholder="Selecciona tu departamento"
      //             error={errors.depAddress}
      //             required
      //             isDesktop={isDesktop}
      //           />
      //         </div>

      //         {/* Ciudad */}
      //         <div>
      //           <FilterableSelect
      //             options={citysSelect.map((cityAddress) => ({
      //               label: cityAddress,
      //               value: cityAddress,
      //             }))}
      //             label={"Ciudad"}
      //             value={formData.cityAddress}
      //             onChange={handleInputChange}
      //             name="cityAddress"
      //             placeholder="Selecciona tu ciudad"
      //             error={errors.cityAddress}
      //             required
      //             isDesktop={isDesktop}
      //           />
      //         </div>
      //       </div>
      //     </div>
      //   );

      case 5:
        return (
          <div
            className="flex flex-col items-center justify-center space-y-6 text-center px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                ¿A qué te dedicas?
              </p>
            )}
            <div className="w-full max-w-sm">
              <CardSelect
                data={ocupationOptions}
                value={formData.ocupation}
                name="ocupation"
                onChange={handleInputChange}
                error={errors.ocupation}
                multiple={false}
                isDesktop={isDesktop}
              />
            </div>
          </div>
        );

      case 6:
        return (
          <div
            className="flex flex-col items-center justify-center space-y-6 text-center px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                ¿Cuantos son tus ingresos mensuales?
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <StepInput
                name="monthlyExpenses"
                inputMode="numeric"
                value={formData.monthlyExpenses}
                label={"Tus Ingresos"}
                onChange={handleAmountChange}
                error={errors.monthlyExpenses}
                required
                placeholder="2.000.000"
                autoFocus={true}
                minLength={9}
                maxLength={10}
                type="text"
                isDesktop={isDesktop}
                iconLeft={<span className="text-xl">$</span>}
              />

              <div
                className="bg-grayP"
                style={{
                  borderRadius: "12px",
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background: "#2a2550",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="text-xl">$</span>
                </div>
                <p style={{ fontSize: "14px", margin: 0, textAlign: "start" }}>
                  <span style={{ color: "white" }}>
                    Verificaremos tus ingresos, por favor coloca tus ingresos
                    reales.
                  </span>
                </p>
              </div>
            </div>
          </div>
        );

      case 7:
        return (
          <div
            className="space-y-6 text-center flex flex-col px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
              gap: isDesktop
                ? "clamp(20px, 3vh, 40px)"
                : "clamp(16px, 2vh, 24px)",
              padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
            }}
          >
            {!isDesktop && (
              <p className="text-muted-foreground font-bold2 text-xl sm:text-2xl">
                ¿Dónde recibes tus ingresos?
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <FilterableSelect
                options={newBankAccount.map((banck) => ({
                  label: banck.label,
                  value: banck.value,
                  icon: banck.icon,
                }))}
                value={formData.bankAccount}
                onChange={handleInputChange}
                name="bankAccount"
                label={"Banco"}
                placeholder="Selecciona tu banco"
                error={errors.bankAccount}
                required
                isDesktop={isDesktop}
              />
            </div>

            <BottomSheet
              open={dialogOpenBankSelected}
              onOpenChange={setDialogOpenBankSelected}
              isDesktop={isDesktop}
              footerContent={
                <div className="flex gap-5 h-16">
                  <PrevButton
                    onBack={() => {
                      handleToggleDialogBankSelected(false);
                    }}
                    label={"Editar"}
                  />
                  <NextButton
                    onNext={() => {
                      handleToggleDialogBankSelected(true);
                    }}
                    label={"Continuar"}
                  />
                </div>
              }
            >
              <div
                className="flex flex-col items-center justify-evenly space-y-3 w-full h-full"
                style={{
                  gap: !isDesktop && "20px",
                }}
              >
                <div className="w-87.5 flex flex-col items-center justify-center text-center pt-5">
                  <p className="text-white text-lg font-bold2 mb-2">
                    Confirmanos si en este banco recibes tus ingresos para
                    continuar con tu solicitud.
                  </p>
                </div>

                <div className="flex flex-col justify-around gap-7 items-center">
                  {formData.bankAccount === 30 ||
                    formData.bankAccount === 31 ? (
                    <img
                      src={
                        formData.bankAccount === 30
                          ? "/png/nequi.png"
                          : formData.bankAccount === 31 &&
                          "/png/daviplata-blanco.png"
                      }
                      alt="Bancolombia"
                      style={{
                        maxWidth: "none",
                        height: formData.bankAccount === 30 ? "25px" : "60px",
                        width: formData.bankAccount === 30 ? "75px" : "130px",
                      }}
                    />
                  ) : (
                    <span className="flex flex-col items-center">
                      {homologateBankNameAccount(formData.bankAccount, "icon")}
                      <label className="font-bold2">
                        {homologateBankNameAccount(
                          formData.bankAccount,
                          "label",
                        )}
                      </label>
                    </span>
                  )}
                </div>
                <div className="w-87.5 flex flex-col items-center justify-center text-center px-4 py-6 rounded-xl bg-metal">
                  <p className="text-white font-semibold2 mb-2">
                    Realizaremos el desembolso de tu crédito en la misma cuenta
                    donde recibes tus ingresos, no podrás cambiarlo después. Si
                    deseas cambiarlo, por favor hazlo ahora dando click en el
                    botón editar.
                  </p>
                </div>
              </div>
            </BottomSheet>
          </div>
        );

      case 8:
        return (
          <div
            className="space-y-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <div className="text-center flex flex-col items-center">
                <h2
                  className="font-bold2 text-foreground mb-2"
                  style={{ fontSize: "20px" }}
                >
                  Woohoo!!, casi listos 🚀✨
                </h2>
              </div>
            )}
            <div
              className="space-y-3"
              style={{
                width: "-webkit-fill-available",
                display: isDesktop && "flex",
                justifyContent: isDesktop && "center",
                alignItems: isDesktopReize && "center",
              }}
            >
              <div
                className="grid grid-cols-1 gap-4 text-sm "
                style={{
                  backgroundColor: isDesktop ? "#565584" : "#2C2447",
                  padding: "5px 16px",
                  borderRadius: "8px",
                  width: isDesktop && "60%",
                  gap: isDesktop && "5px",
                  height: isDesktopReize && "65%",
                }}
              >
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Apellido
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {formData.firstlastname}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(1);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Monto solicitado
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      ${formData.requestedAmount} COP
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(2);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Edad
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {formData.age} años
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(2);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div> */}
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Estado civil
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {
                        maritalStatusOptions.find(
                          (o) => o.value === formData.maritalStatus,
                        )?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(3);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Genero
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {
                        genderOptions.find((o) => o.value === formData.gender)
                          ?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(4);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div> */}
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Estudios
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {
                        educationLevelOptions.find(
                          (o) => o.value === formData.educationLevel,
                        )?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(4);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Departamento
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {formData.depAddress}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(6);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div> */}
                {/* <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Ciudad
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {formData.cityAddress}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(6);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div> */}
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Ocupación
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      {
                        ocupationOptions.find(
                          (o) => o.value === formData.ocupation,
                        )?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(5);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Ingresos
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "16px" }}
                    >
                      ${formData.monthlyExpenses} COP
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(6);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Banco
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2 text-end"
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      {homologateBankNameAccount(
                        formData.bankAccount,
                        "icon",
                      ) && (
                          <span className="flex items-center">
                            {homologateBankNameAccount(
                              formData.bankAccount,
                              "icon",
                            )}
                          </span>
                        )}
                      {
                        newBankAccount.find(
                          (dept) => dept.value === formData.bankAccount,
                        )?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(7);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      {/* Mantiene tus alerts y modal igual */}
      {alertSession && (
        <>
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      )}

      <BottomSheet
        open={openDialogInfo}
        isDesktop={isDesktop}
        onOpenChange={handleOpenDialogInfoAccount}
        footerContent={
          <div className="flex items-center justify-center gap-5 h-16">
            <NextButton
              finishLabel={"Entendido"}
              isLastStep={true}
              showIconNext={false}
              onNext={(e) => {
                handleOpenDialogInfoAccount(e);
              }}
              isUnicButtom={true}
            />
          </div>
        }
      >
        <div
          style={{
            height: "60%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <h1
            className="font-bold2 text-white text-center text-lg"
            style={{
              margin: "20px",
            }}
          >
            Debes de tener presente estas indicaciones para solicitar tu
            crédito.
          </h1>

          <div className="w-full ">
            <div className="text-center mb-6 flex flex-col items-center">
              <div className="flex flex-col gap-4">
                <div
                  className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                >
                  <div
                    className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                  >
                    <IdCard size={30} className="text-white" strokeWidth={2} />
                  </div>

                  <div className="text-left">
                    <h3 className="text-xl font-semibold2 text-white">
                      {"Cédula de ciudadania"}
                    </h3>

                    <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                      {
                        "Recuerda tener tu documento físico para validar tu identidad"
                      }
                    </p>
                  </div>
                </div>
                <div
                  className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                >
                  <div
                    className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                  >
                    <Landmark
                      size={30}
                      className="text-white"
                      strokeWidth={2}
                    />
                  </div>

                  <div className="text-left">
                    <h3 className="text-xl font-semibold2 text-white">
                      {"Cuenta bancaria"}
                    </h3>

                    <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                      {
                        "Es importante para realizar la tranferencia del crédito."
                      }
                    </p>
                  </div>
                </div>
                <div
                  className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                >
                  <div
                    className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                  >
                    <Phone size={30} className="text-white" strokeWidth={2} />
                  </div>

                  <div className="text-left">
                    <h3 className="text-xl font-semibold2 text-white">
                      {"Celular personal"}
                    </h3>

                    <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                      {
                        "Te estaremos enviando un código para finalizar la solicitud."
                      }
                    </p>
                  </div>
                </div>
                <div
                  className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                >
                  <div
                    className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                  >
                    <CameraIcon className="w-7.5 h-7.5 text-white" />
                  </div>

                  <div className="text-left">
                    <h3 className="text-xl font-semibold2 text-white">
                      {"Cámara"}
                    </h3>

                    <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                      {
                        "Asegurate de estar en un lugar con buena iluminación natural."
                      }
                    </p>
                  </div>
                </div>
                <p className="mt-1 text-base leading-6 text-white">
                  {"¡Son indispensable para poder obtener el Crédito.!"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>

      <Fragment>
        {/* StepContainer igual */}
        <div className="w-full h-full">
          <StepContainer
            onNext={() => {
              if (currentStep === 7 && !currentStepResume) {
                handleToggleDialogBankSelected(false);
              } else {
                handleNext();
              }
            }}
            onPrev={handlePrev}
            canGoNext={true}
            canGoPrev={
              currentStep > 1 &&
              currentStep !== totalSteps &&
              !currentStepResume
            }
            currentStepResume={currentStepResume}
            isDesktop={isDesktop}
            errors={isError}
            disabled={isDisabled}
            isLastStep={currentStep === totalSteps}
            isLoading={isLoading}
            nextText={currentText}
            title={stepTitles[currentStep - 1]}
            subtitle={stepSubTitles[currentStep - 1]}
            finishText="Enviar solicitud"
            justification={justification}
            marginTop={marginTop}
            height={height}
          >
            <div
              className={`transition-all duration-300 ease-in-out ${isTransitioning
                ? "opacity-0 translate-x-4"
                : "opacity-100 translate-x-0"
                }`}
              style={{
                width: "-webkit-fill-available",
                overflowY: "auto",
                height: isDesktop ? "-webkit-fill-available" : getFormHeight(),
              }}
            >
              {!isDesktop && (
                <div className="mb-3 text-center flex flex-col items-center">
                  <div className="text-sm mb-1.5" style={{ color: "#c8cbda" }}>
                    Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                  </div>
                  <div
                    className="text-lg font-medium text-gray-800 mt-1"
                    style={{
                      fontSize: 16,
                      fontWeight: 400,
                      width: "190px",
                      lineHeight: "1",
                    }}
                  >
                    {stepTitlesGeneral &&
                      stepTitlesGeneral[currentStepGeneral - 1]}
                  </div>
                </div>
              )}
              {renderStep()}
            </div>
          </StepContainer>
        </div>
      </Fragment>
    </>
  );
};

export default DatosPersonalesForm;
